import { pageId, categoryId } from '@/infrastructure/Configuration'
export default {
  labelsLoaded: false,
  articles: [],
  promotedArticles: null,
  filters: {
    offset: 1,
    pageId: pageId,
    limit: 6,
    categoryId
  },
  totalPages: 0,
  loadingArticles: false,
  tagList: null,
  selectedTag: null,
  isInitialDataFetched: false
}
